const languagesByType = (languages, type) => languages.filter((item) => item.record_language_type === type);

const extractLanguageIds = (languages) => languages.map((item) => item.language.id);

const determineLanguageDifferences = (preferredLanguages, formValues) => {
  const existingSpokenLanguages = languagesByType(preferredLanguages, 'spoken');
  const existingWrittenLanguages = languagesByType(preferredLanguages, 'written');

  const existingSpokenLanguageIds = extractLanguageIds(existingSpokenLanguages);
  const existingWrittenLanguageIds = extractLanguageIds(existingWrittenLanguages);

  const finalSpokenLanguages = formValues.preferred_spoken_languages.map((item) => item.id);
  const finalWrittenLanguages = formValues.preferred_written_languages.map((item) => item.id);

  const languagesToAdd = [
    ...finalSpokenLanguages
      .filter((id) => !existingSpokenLanguageIds.includes(id))
      .map((id) => ({ language_id: id, record_language_type: 'spoken' })),
    ...finalWrittenLanguages
      .filter((id) => !existingWrittenLanguageIds.includes(id))
      .map((id) => ({ language_id: id, record_language_type: 'written' })),
  ];

  const languagesToRemove = [
    ...existingSpokenLanguages
      .filter((item) => !finalSpokenLanguages.includes(item.language.id))
      .map((item) => ({ id: item.id })),
    ...existingWrittenLanguages
      .filter((item) => !finalWrittenLanguages.includes(item.language.id))
      .map((item) => ({ id: item.id })),
  ];

  return { languagesToAdd, languagesToRemove };
};

export default determineLanguageDifferences;
